import AcademicDetailsComponent from '../CheckDetailsComponents/AcademicDetailsComponent';
import ComputerDetailsComponent from '../CheckDetailsComponents/ComputerDetailsComponent';
import TechDetailsComponents from '../CheckDetailsComponents/TechDetailsComponents';
import './DesignFirst.css'; 

import JobExperianceComp from './Designsecond components/JobExperianceComp';
let DesignFirst = (props) => {
    let Designemptydata = {
        AcademicDataStream: props.AcademicData[0].ExamName,
        ComputerDataCourseName: props.ComputerData[0].CourseName,
        TechnicalDataCourseName: props.TechDataexp[0].TechCourseName, 
        WorkexperienceYear : props.ExperienceData[0].ExperianceYear,
        PassPortNumber : props.sendpassportdata.paassportnumber,
        HeIght : props.sendphysicaldata.Height,  
    };
  
    
    // props.AcademicData.pop();
   
    
    let checkemptyfields =()=>{
    
        let academichildren = document.querySelector("#academicdata");
        let computerchildren = document.querySelector(".computertblcont");  
        let technicalchildren = document.querySelector(".techincaltblcont");   
        let workexperienceparent = document.querySelector(".Exp_main_cont");
        let passportdatacont = document.querySelector('.DesFrstpassportdet');
        let physicaldatacont = document.querySelector('.DesFrstphysicaldet');
        if(Designemptydata.AcademicDataStream == "" || Designemptydata.AcademicDataStream == null){
            academichildren.style.display = "none";   

        }  
        if(Designemptydata.ComputerDataCourseName == "" || Designemptydata.ComputerDataCourseName == null){
            computerchildren.style.display = "none";
        }
        if(Designemptydata.TechnicalDataCourseName == "" || Designemptydata.TechnicalDataCourseName == null){
            technicalchildren.style.display = "none";
        }     
        if(Designemptydata.WorkexperienceYear == "" || Designemptydata.WorkexperienceYear == null){
            workexperienceparent.style.display = "none";     
        }
        if(Designemptydata.PassPortNumber == "" || Designemptydata.PassPortNumber == null){
            passportdatacont.style.display = "none";
        } 
        if(Designemptydata.HeIght == "" || Designemptydata.HeIght == null){
            physicaldatacont.style.display = "none"; 
        } 
    
    }
   setTimeout(() => {
        checkemptyfields();
   }, 50);  

   let printfunction=()=>{
     window.print();
} 
   
      
    return(
        <div className='main_contt'>  
        <div className='descont'>
            <div className='Res_heading_cont'><h2 className='Resume_heading'>Resume</h2></div>
           <div className='main_cont_of_left_right'>  
                <div className='left_cont'>   
                    <div className='img_and_heading_cont'>
                        <div className='img_cont'>   
                             
                            {
                                props.imagedataexp === "" ?  <img alt='Photo' className='picfrommain' src={props.UsersPersonlD.Imagge}/> : <img alt='photo' className='picfromdemo' src={props.imagedataexp}/>
                            }

                        </div>
                        <h2 className='applicant_name_heading'>{props.UsersPersonlD.Name}{props.Userdata.applicantname}</h2>
                    </div>    
                    <div className='carrier_cont'>
                        <ul className='carrier_ul'>
                            <h3 className='carrier_heading'>Carrier Objective</h3>
                            <li className='carrier_li'>{props.UsersPersonlD.cardata}{props.carrierdataf}</li>
                        </ul>
                    </div>
                    <div className='contact_details_cont'>
                        <ul className='contact_ul'>
                            <h3 className='contact_heading'>Contact Details</h3>
                            <li className='contact_li'>Mobile Number:- <span>{props.UsersPersonlD.mobnum}{props.Userdata.MobileNum}</span></li>
                            <li className='contact_li'>Email ID:- <span>{props.UsersPersonlD.Email_ID}{props.Userdata.Email}</span></li>
                            <li className='contact_li'>Alternate No:- <span>{props.UsersPersonlD.Alternate}{props.Userdata.Altnum}</span></li>  
                                
                        </ul>

                    </div>
                    <div className='address_cont'>
                    <ul className='address_ul'>
                            <h3 className='address_heading'>Address Details</h3>
                            <li className='address_li'><span>House no:-<span>{props.UsersPersonlD.hnum}{props.Userdata.Hnum}</span></span></li>
                            <li className='address_li'><span>Village:-<span>{props.UsersPersonlD.Village}{props.Userdata.Vill}</span></span></li>
                            <li className='address_li'><span>Post Office:-<span>{props.UsersPersonlD.Post_Office}{props.Userdata.post}</span></span></li>
                            <li className='address_li'><span>District:-<span>{props.UsersPersonlD.District}{props.Userdata.city}</span></span></li>
                            <li className='address_li'><span>Thana:-<span>{props.UsersPersonlD.Thana}{props.Userdata.police}</span></span></li>
                            <li className='address_li'><span>State:-<span>{props.UsersPersonlD.State}{props.Userdata.state}</span></span></li>
                            <li className='address_li'><span>Pin Code:-<span>{props.UsersPersonlD.Pin_Code}{props.Userdata.pincode}</span></span></li>
                        </ul>
                    </div> 
                </div>
                <div className='right_cont'>
                    <div className='Personal_details_cont'>
                        <table className='table_first'>
                            <caption>Personal Details</caption>
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>{props.UsersPersonlD.Name} {props.Userdata.applicantname
                                    }</td>
                                </tr>
                                <tr>
                                    <td>Father's Name</td>
                                    <td> {props.UsersPersonlD.fname}{props.Userdata.fathername}</td>
                                </tr>
                                <tr>
                                    <td>Mother's Name</td>
                                    <td>{props.UsersPersonlD.Mname}{props.Userdata.mothername}</td>
                                </tr>     
                                <tr>
                                    <td>Date Of Birth</td>
                                    <td>{props.UsersPersonlD.dob}{props.Userdata.date}</td>
                                </tr>
                                <tr>
                                    <td>Nationality</td>
                                    <td>{props.UsersPersonlD.Nationality}{props.Userdata.nationality}</td>
                                </tr>
                                <tr>
                                    <td>Religion</td>
                                    <td>{props.UsersPersonlD.Religion}{props.Userdata.religion}</td>
                                </tr>
                                <tr>
                                    <td>Marrital Status</td>
                                    <td>{props.UsersPersonlD.Marital_Status}{props.Userdata.maritalstatus}</td>
                                </tr>
                                <tr>
                                    <td>Hobby</td>
                                    <td>{props.UsersPersonlD.Hobbies}{props.Userdata.hobbies}</td>
                                </tr>
                                <tr>
                                    <td>Languages</td>
                                    <td>{props.UsersPersonlD.Languages}{props.Userdata.language}</td>
                                </tr>
                            </thead>
                        </table>
                        <table className='table_second' id='academicdata'>
                            <caption>Academic Details</caption>
                            <thead>
                                <tr>
                                    <td>Stream</td>
                                    <td>Board/Univercity</td>
                                    <td>Passing Year</td>
                                    <td>%AGE</td>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.AcademicData.map(
                                        ACTDATA => (
                                            <AcademicDetailsComponent 
                                            Stream = {ACTDATA.ExamName}
                                            BoardUnivercity = {ACTDATA.BoardName}
                                            PassingYearA = {ACTDATA.PassingYear}
                                            PercentageA = {ACTDATA.PercentAge}
                                        />
                                    )
                                    )
                                }

                               
                            </tbody>
                        </table>
                        <table className='table_third computertblcont'>
                            <caption>Computer Qualification</caption>
                            <thead>
                                <tr>
                                    <td>Exam Name</td>
                                    <td>From</td>
                                    <td>Passing Year</td>
                                    <td>%Age</td>
                                </tr>
                            </thead>
                            <tbody>
                                { 
                                    props.ComputerData.map(
                                        CompData => (
                                            <ComputerDetailsComponent
                                            CoursrName = {CompData.CourseName}
                                            FromWhere = {CompData.Frompass}
                                            PassingYearC = {CompData.Compassingy}
                                            PercentageC = {CompData.compercent}
                                    />
                                        )
                                    )
                                }
                            </tbody>
                        </table>
                        <table className='table_fourth techincaltblcont'>
                            <caption>Technical Qualification</caption>
                            <thead>
                                <tr>
                                    <td>Exam Name</td>
                                    <td>Trade</td>
                                    <td>Passing Year</td>
                                    <td>%Age</td>
                                </tr>
                            </thead>
                            {
                                props.TechDataexp.map(
                                    TechData => (
                                        <TechDetailsComponents
                                        TechCourseName = {TechData.TechCourseName}
                                        TechTradeName = {TechData.TechTradeName}
                                        TechPassingYear = {TechData.TechPassingYear}
                                        TechPercentage  = {TechData.TechPercentage}
                                        TechFromWhere = {TechData.Techfromwhere}
                                            
                                        />

                                    )
                                )
                            }
                        </table>
                        <table className='DesFrstpassportdet'>
                                <caption className='desfrstpassprotcaption'>Passport Details</caption>
                                <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>{props.UsersPersonlD.Name}</td>
                                </tr> 
                                <tr>
                                    <td>Passport Number</td> 
                                    <td>{props.sendpassportdata.paassportnumber}</td>
                                </tr>
                                <tr>
                                    <td>Issuing Date</td>
                                    <td>{props.sendpassportdata.passportissuingdate}</td>
                                </tr>
                                <tr>
                                    <td>Expiry Date</td>
                                    <td>{props.sendpassportdata.passportexpirydate}</td>
                                </tr>
                                <tr>
                                    <td>District</td>
                                    <td>{props.sendpassportdata.passportdistrict}</td>
                                </tr>
                            </tbody>
                        </table>


                        <table className='DesFrstphysicaldet'>
                            <caption className='desfrtphysicalcaption'>Physical details</caption>
                            <tbody>
                                <tr>
                                    <td>Height</td>  
                                    <td>Weight</td>
                                    <td>Blood Group</td>
                                    <td>PwP Disability</td>
                                </tr>
                                <tr>
                                    <td>{props.sendphysicaldata.Height}</td>
                                    <td>{props.sendphysicaldata.weight}</td>
                                    <td>{props.sendphysicaldata.BloodGroup}</td>
                                    <td>{props.sendphysicaldata.Pwpdisability}</td>
                                </tr>
                            
                            
                            </tbody>
                        </table>
 
                        <div className='Exp_main_cont'>
                            <h4 className='exp_heading'>Work Experience</h4>
                            <ul>
                                {  
                                    props.ExperienceData.map(
                                        ExpdataToExpComp =>(
                                            <JobExperianceComp
                                            ExperienceData={ExpdataToExpComp}  
                                            />
                                        )
                                    )
                                }
                                
                                
                            </ul>
                            
                        </div>
                        <div className='declaration_cont'>
                            <ul>
                                <h2 className='declaration_form'>Declaration</h2>
                                <li>I hereby declare that all the statement made in this resume are true, complete and correct to the Knowledge.</li>
                            </ul>
                        </div>
                        <div className='sign_name_cont'>
                            <span className='signature'>Signature....................</span>
                            <span>Date.......................</span>  

                        </div>
                    </div>
                </div>
           </div>
        </div>
            <div className='printbtn' style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <button style={{padding: "10px 20px", backgroundColor: "lightblue", border: "none", color: "black", borderRadius: "5px",  fontSize: "22px"}} onClick={printfunction}>Print</button>
            </div>
        </div>
    );
}
export default DesignFirst;